import {
  CREATEORUPDATEWALLETOWNER_SUCCESS,
  CREATEORUPDATEWALLETOWNER_FAILED,
  RESET_CREATEORUPDATEWALLETOWNER,
  LOADING_CREATEORUPDATEWALLETOWNER,
  NETWORK_ERROR_CREATEORUPDATEWALLETOWNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CREATEORUPDATEWALLETOWNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case CREATEORUPDATEWALLETOWNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case CREATEORUPDATEWALLETOWNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_CREATEORUPDATEWALLETOWNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_CREATEORUPDATEWALLETOWNER:
      return (state = initialState);
    default:
      return state;
  }
};
